'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    'zh-cn': {
        placeholder: '请选择时间',
        clear: '清除',
        hour: '时',
        minute: '分',
        second: '秒'
    },
    'zh-tw': {
        placeholder: '請選擇時間',
        clear: '清除',
        hour: '時',
        minute: '分',
        second: '秒'
    },
    'en-us': {
        placeholder: 'Select a Time',
        clear: 'Clear',
        hour: 'H',
        minute: 'M',
        second: 'S'
    }
};

exports['default'] = locale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@alife/next/lib/_components/@alife/next-time-picker/lib/locale/index.js
// module id = 343
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11